module.exports = __webpack_public_path__ + "static/media/client15.f5db75bc.webp";